import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class MembershipPointQueryCriteriaClass extends BaseCriteriaModel {

  local_created_time_from?: Optional<string> = Optional.empty();
  local_created_time_to?: Optional<string> = Optional.empty();
  event_code?: Optional<string> = Optional.empty();
  app_id?: Optional<string> = Optional.empty();
  hdr_guid?: Optional<string> = Optional.empty();
}

export class MembershipPointCriteriaModelQuery {
  query = '';

  constructor(MembershipPointCriteriaModel: MembershipPointQueryCriteriaClass) {

    if (!MembershipPointCriteriaModel) {
      return;
    }

    this.query += MembershipPointCriteriaModel.local_created_time_from.filter(x => x !== '').map(x => '&local_created_time_from=' + x).orElse('');
    this.query += MembershipPointCriteriaModel.local_created_time_to.filter(x => x !== '').map(x => '&local_created_time_to=' + x).orElse('');
    this.query += MembershipPointCriteriaModel.event_code.filter(x => x !== '').map(x => '&event_code=' + x).orElse('');
    this.query += MembershipPointCriteriaModel.app_id.filter(x => x !== '').map(x => '&app_id=' + x).orElse('');
    this.query += MembershipPointCriteriaModel.hdr_guid.filter(x => x !== '').map(x => '&hdr_guid=' + x).orElse('');

    this.query += '&status=' + MembershipPointCriteriaModel.status;
    this.query += '&orderBy=' + MembershipPointCriteriaModel.orderBy;
    this.query += '&order=' + MembershipPointCriteriaModel.order;
    this.query += '&offset=' + MembershipPointCriteriaModel.offset + '&limit=' + MembershipPointCriteriaModel.limit;
  }
}
